export const INP_TRACKING_PAGE_LEVEL_FLAG = 'track_inp_event';
export const INP_TRACKING_GLOBAL_FLAG = 'collectInpData';
export const INP_TRACKING_INITIALIZED = 'inp_tracking_initialized';
export const INP_LOWER_BOUND_CMS_LABEL = 'inpThreshold';
export const DEFAULT_INP_LOWER_BOUND = 200;
export const INP_EVENT_NAME = 'inp';
export const DOM_NODE_STRING_LIMIT = 300;
